// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K5dV","content":"styles_content__30lIp"};